import { authorizedFetch } from "."
import type { HttpResponse } from "../redux/http/http.types"
import { get } from "../services/HttpService"
import type { MapDetailDto, MapDto } from "./../models/models"

export async function getMap(mapId: string): Promise<MapDetailDto> {
  const response: HttpResponse<MapDetailDto> = await get<MapDetailDto>("map", `maps/${mapId}`)

  return response.data!
}

export async function getMapByPage(page: number, section: string): Promise<MapDetailDto | undefined> {
  const response: HttpResponse<MapDetailDto> = await get<MapDetailDto>("map", `maps?page=${page}&section=${section}`)

  return response.data
}

export async function getRecentMaps(count: number): Promise<MapDto[]> {
  const response: HttpResponse<MapDto[]> = await get<MapDto[]>("map", `maps/recent?count=${count}`)

  return response.data!
}

export async function getMapListByChapter(chapterId: string): Promise<MapDto[]> {
  const response: HttpResponse<MapDto[]> = await get<MapDto[]>("map", `chapters/${chapterId}/maps`)

  return response.data!
}

export async function getMapListByRegion(regionId: string): Promise<MapDto[]> {
  const response: HttpResponse<MapDto[]> = await get<MapDto[]>("map", `regions/${regionId}/maps`)

  return response.data!
}

export async function getMapListByTheme(themeId: string): Promise<MapDto[]> {
  const response: HttpResponse<MapDto[]> = await get<MapDto[]>("map", `themes/${themeId}/maps`)

  return response.data!
}

export async function getMapImage(assetId: string, prefix?: string): Promise<Response> {
  const queryString: string = `assetId=${assetId}${prefix ? `&prefix=${prefix}` : ""}`
  return await authorizedFetch(`maps/image?${queryString}`)
}
